import { createStore } from '../_core/createStore';
import { lazyStore } from './lazyStore';

const useLazyStore = createStore({
  creator: lazyStore,
  id: 'lazy',
  middlewares: {
    devtools: true,
  },
});

export default useLazyStore;
